<div class="export-dialog">
  <h1 mat-dialog-title>„{{ data.folder.name }}“ exportieren</h1>
  <mat-dialog-content>
    <mat-radio-group [(ngModel)]="format" aria-label="Format" class="format-group">
      <mat-radio-button value="PDF">
        PDF
        <span class="gray format-hint">zum Drucken, mit Vorschau im Browser</span>
      </mat-radio-button>
      <mat-radio-button value="XLSX">
        Excel (XLSX)
        <span class="gray format-hint">für Excel, LibreOffice und andere Tabellenprogramme, ein Tabellenblatt pro Bereich</span>
      </mat-radio-button>
    </mat-radio-group>

    @if (isEmpty) {
      <p class="gray">Die Sammelmappe ist leer, die Datei enthält nur einen Hinweis.</p>
    }

    @if (loading) {
      <div class="center-content pad16">
        <mat-progress-spinner diameter="32" mode="indeterminate"></mat-progress-spinner>
      </div>
    } @else if (sections.length > 0) {
      <mat-expansion-panel class="settings-panel">
        <mat-expansion-panel-header>
          <mat-panel-title>Erweiterte Einstellungen</mat-panel-title>
          <mat-panel-description>Spalten pro Bereich auswählen</mat-panel-description>
        </mat-expansion-panel-header>

        @for (selection of sections; track selection.section.section) {
          <div class="section">
            <mat-checkbox (change)="toggleSection(selection, $event.checked)"
                          [checked]="allSelected(selection)"
                          [indeterminate]="someSelected(selection)"
                          class="section-title">
              <b>{{ selection.section.label }}</b>
              <span class="gray"> ({{ selection.entryCount }} {{ selection.entryCount === 1 ? 'Eintrag' : 'Einträge' }})</span>
            </mat-checkbox>
            <div class="fields">
              @for (field of selection.section.fields; track field.key) {
                <mat-checkbox (change)="toggleField(selection, field.key, $event.checked)"
                              [checked]="selection.selected.has(field.key)">
                  {{ field.label }}
                </mat-checkbox>
              }
            </div>
            @if (selection.selected.size === 0) {
              <span class="gray section-hint">Dieser Bereich wird nicht exportiert.</span>
            }
          </div>
        }
        <button (click)="resetDefaults()" mat-button>
          <mat-icon>restart_alt</mat-icon>
          Standard wiederherstellen
        </button>
      </mat-expansion-panel>
    }
    @if (nothingSelected) {
      <p class="warning">Es sind keine Spalten ausgewählt.</p>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    @if (exporting) {
      <mat-progress-spinner class="export-spinner" diameter="24" mode="indeterminate"></mat-progress-spinner>
    }
    <button mat-dialog-close mat-raised-button>Schließen</button>
    @if (format === 'PDF') {
      <button (click)="preview()" [disabled]="exporting || loading || nothingSelected" mat-raised-button>
        <mat-icon>visibility</mat-icon>
        Vorschau
      </button>
    }
    <button (click)="download()" [disabled]="exporting || loading || nothingSelected" color="primary" mat-raised-button>
      <mat-icon>download</mat-icon>
      Herunterladen
    </button>
  </mat-dialog-actions>
</div>
